import axios, { AxiosInstance } from 'axios';
import { API_URL } from './constants';
import { AUTH_LOCAL_STORAGE_KEY, AuthModel } from '../../modules/auth';

export interface ApiResponse<T> {
    success: boolean;
    data: T;
    errorList?: string[];
}

class Api {
    private axiosInstance: AxiosInstance;
    constructor() {
        this.axiosInstance = axios.create({
            baseURL: API_URL,
            // withCredentials: true,
            responseType: 'json',
            timeout: 30000,
        });

        // Coloca o empresa_id no corpo da requisição e o token de acesso no header
        this.axiosInstance.interceptors.request.use(function (config) {
            const { company_id, api_token } = JSON.parse(localStorage.getItem(AUTH_LOCAL_STORAGE_KEY) ?? '{}') as AuthModel;
            if (api_token) {
                config.headers = { ...config.headers, Authorization: `Bearer ${api_token}` };
            }
            const isMultipart = config.headers?.['Content-Type'] === 'multipart/form-data';
            if (!isMultipart && company_id && !config.data?.length) {
                config.data = {
                    ...config.data,
                    id_empresa: company_id
                }
            }
            return config;
        }, function (error) {
            // Do something with request error
            return Promise.reject(error);
        });
        this.axiosInstance.interceptors.response.use(function (config) {
            if (config.data.success === false) {
                return Promise.reject(config.data.errorList?.[0] ?? 'Erro na requisição');
            }
            return config;
        }, function (error) {
            // respostas de erro do backend (ex.: 401) tambem trazem o ApiResponse com a mensagem
            const mensagem = error?.response?.data?.errorList?.[0];
            return Promise.reject(mensagem ?? error);
        });
    }
    async get<T>(url: string) {
        const response = await this.axiosInstance.get<ApiResponse<T>>(url);
        return response.data
    }
    async post<T>(url: string, data?: any, config?: any) {
        const response = await this.axiosInstance.post<ApiResponse<T>>(url, data, config);
        return response.data
    }

    async put<T>(url: string, data?: any) {
        const response = await this.axiosInstance.put<ApiResponse<T>>(url, data);
        return response.data
    }
    async delete(url: string) {
        const response = await this.axiosInstance.delete(url);
        return response.data
    }
}

const api = new Api();

export { api }
